
export const getStatusText = (transactionStatus) => {
  switch(transactionStatus) {
    case 'authorize':
    case 'pending': return 'Waiting your payment confirmation.';
    case 'capture':
    case 'settlement': return 'Your payment has been paid successfully.';
    case 'deny': return 'Your payment has been denied.';
    case 'cancel': return 'Your payment has been cancelled.';
    case 'expire': return 'Your payment has been expired.';
    default: return 'We got something issues when processing your payment.';
  }
}

export const getStatusDetailText = (transactionStatus) => {
  // const hasStatus = ['capture', 'authorize', 'refund', 'partial_refund', 'chargeback', 'partial_chargeback'].includes(transactionStatus);
  const hasStatus = ['refund', 'partial_refund', 'chargeback', 'partial_chargeback'].includes(transactionStatus);
  return hasStatus?
    `(${transactionStatus.replace(/_/, ' ')
    .split(' ')
    .reduce((acc, str, index) => {
      return acc += ' '+ str.split('')
        .map((c, i)=> i===0 ? c.toUpperCase(): c)
        .join('');
    },"").trim()})`
    : null;
}

export const getSelectedPayment = (paymentMethod, bankCode, paymentMethodReq = '') => {
  const isDebitCard = paymentMethodReq.includes('debit');
  switch(paymentMethod) {
    case 'virtual_account':
    case 'echannel':
    case 'bank_transfer': return bankCode? `${bankCode} - Virtual Account` : 'Virtual Account';
    case 'credit_card': return isDebitCard? 'Debit Card' : 'Credit Card';
    default: return paymentMethod;
  }
}